import { Checkbox, Divider } from '@cleartrip/bento'
import classNames from 'classnames'
import { PriceContext } from 'context/itinerary'
import languageTranslate from 'locale'
import React, { Children, useContext, useEffect, useMemo, useState } from 'react'
import { PROVIDER_TRIPADD } from './constants'
import { ItemCard } from './item-card'
const reactVersion = React.version

const TripAdd = ({
    itineraryData = {},
    setSelectedInsuranceDetails,
    onTermsAndConditionsChange,
    customPayload,
    addServiceWithoutAcceptingTerms
}) => {
    //global state use as context to store price summary
    const [_, setPriceSummary] = useContext(PriceContext)
    const { vasAncillaries = [] } = itineraryData || {}
    const tripAddDataArr = useMemo(() => {
        return vasAncillaries?.filter(item => item.vasProvider === PROVIDER_TRIPADD) || {}
    }, [])

    /**
     * As all the trip add terms and conditions are same for all the trip add items
     * we are using the first trip add item terms and conditions
     * to show the terms and conditions checkbox
     */
    const { vasDetails = [] } = tripAddDataArr?.[0] || {}
    const {
        termsAndConditions = {
            checked: false,
            mandatory: true,
            url: ''
        }
    } = vasDetails?.[0] || {}

    /*
    by default the terms and conditions checkbox is checked , we are not using response value, if term and condition default value required  to set according to the response data we can use the below commented code

    // const [acceptTerms, setAcceptTerms] = useState(termsAndConditions?.checked || false)
    */
    const [acceptTerms, setAcceptTerms] = useState(true)

    /**
     * toggleTermsFlag is used to toggle the terms and conditions checkbox
     * when the checkbox is clicked
     */
    const toggleTermsFlag = () => {
        setAcceptTerms(prev => !prev)
        onTermsAndConditionsChange(!acceptTerms)
    }

    const updatePrice = latestObj => {
        setPriceSummary(prev => {
            return { ...prev, ...latestObj }
        })
    }

    useEffect(() => {
        /**
         * we are making the terms and conditions checkbox checked by default, if latter we need to set the default value according to the response data we can use the below commented code
         * if (termsAndConditions?.checked) onTermsAndConditionsChange(termsAndConditions?.checked)
         */
        onTermsAndConditionsChange(true)
    }, [])

    if (tripAddDataArr?.length === 0) {
        return null
    }
    return (
        <div className="ba bc-neutral-100 br-12" style={{ overflow: 'hidden' }}>
            <div style={{ padding: '16px 24px' }} className="bg-secondary-100">
                <h3 className="fs-4">Recommended For you</h3>
                <p className="fs-3 c-neutral-600">Enhance your travel experience with these services</p>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '24px' }}>
                {Children.toArray(
                    tripAddDataArr
                        ?.sort((a, b) =>
                            a?.vasDetails?.at(0)?.autoSelected === true
                                ? -1
                                : b?.vasDetails?.at(0)?.autoSelected === true
                                ? 1
                                : 0
                        )
                        ?.map((tripAddData, index) => {
                            return (
                                <>
                                    <ItemCard
                                        tripAddData={tripAddData}
                                        updatePrice={updatePrice}
                                        setSelectedInsuranceDetails={setSelectedInsuranceDetails}
                                        customPayload={customPayload}
                                    />
                                </>
                            )
                        })
                )}
            </div>

            {/* terms and conditions  */}
            <Divider />
            <div className=" bbr-2 bc-neutral-100 px-4 py-3 flex flex-between" style={{ borderTopColor: '#F7F7F7' }}>
                <div className="flex flex-middle">
                    <img
                        src={'https://app.tripadd.com/assets/tripadd/logo.png'}
                        alt={'Trip add logo'}
                        style={{ width: '40px' }}
                    />

                    <a
                        href={termsAndConditions?.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="fs-2 fw-400 c-secondary-500 mx-2 td-none hover:td-underline"
                    >
                        {languageTranslate('View terms & conditions')}
                    </a>
                </div>
                <div className="flex flex-middle">
                    <Checkbox
                        className="bc-neutral-200 mx-2"
                        checked={acceptTerms}
                        onChange={toggleTermsFlag}
                        data-testid="termsFlag"
                    >
                        <p
                            className={classNames('fs-2 ', {
                                'c-neutral-700': acceptTerms,
                                'c-error-500': addServiceWithoutAcceptingTerms && !acceptTerms
                            })}
                        >
                            {languageTranslate('I accept the terms and conditions of this policy')}
                        </p>
                    </Checkbox>
                </div>
            </div>
        </div>
    )
}

export default TripAdd
export * from './constants'
